import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import LoginPage from "@/pages/LoginPage";
import BugIntakePage from "@/pages/BugIntakePage";
import { getToken, verifyToken } from "@/lib/api";

const Protected = ({ children }) => {
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    const run = async () => {
      const token = getToken();
      if (!token) return setState({ loading: false, ok: false });
      const ok = await verifyToken();
      setState({ loading: false, ok });
    };
    run();
  }, []);

  if (state.loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-bone"
        data-testid="protected-loading"
      >
        <div className="text-ink-muted text-sm">Loading...</div>
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App bg-bone text-ink min-h-screen">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: "16px",
            border: "1px solid #E2E8DE",
            background: "#FFFFFF",
            color: "#2C3B2E",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <BugIntakePage />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
